import React from 'react';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import SEO from '../seo';
import { Hero } from './hero';
import { Articles } from './articles';
import { RelatedTopics } from './related-topics';
import { useTopicContext } from './context';

const AnalyticEvents = ({ trackEvent, data }) => {
  trackEvent('page_hit', { page_hit: 'topic', data });
};

export const Topic = () => {
  const { trackEvent } = useAnalytics();
  const { strapiTopic, isLoading } = useTopicContext();
  if (!isLoading) AnalyticEvents({ trackEvent, data: strapiTopic });

  const {
    topic_name,
    topic_url,
    topic_seo_title_tag,
    topic_seo_meta_description,
    topic_seo_keywords
  } = strapiTopic || {};

  return (
    <>
      <SEO
        title={topic_seo_title_tag || topic_name}
        description={topic_seo_meta_description}
        keywords={topic_seo_keywords}
        url={topic_url}
      />

      <Hero />

      <Articles />

      <RelatedTopics />
    </>
  );
};

export default Topic;
